/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { LoadingItem } from '@coursera/cds-core';

// TODO(CDS-2256): CDS should expose a standalone LoadingIcon (spinner only, no label).
// This component hacks LoadingItem by hiding its label container so only
// the indeterminate SVG ring is rendered. Remove once CDS ships a primitive.
//
// ⚠️ Coupling risk: The selector `[role='status'] > div` targets LoadingItem's
// internal label wrapper. If CDS changes that markup (e.g. adds a wrapper
// element, renames the role, or restructures the label), the label will reappear
// or the spinner layout will break silently. Track the CDS ticket and remove
// this workaround once a first-class spinner primitive is available.
const styles = {
  root: css`
    display: inline-flex;

    /*
     * LoadingItem renders [role="status"] > [svg.spinner, div.label-wrapper].
     * Hiding the label wrapper div leaves only the SVG as a flex item so it
     * centers naturally. Targeting h3 alone doesn't work because the label is
     * wrapped in a Delayed component that may not have mounted yet.
     */
    [role='status'] > div {
      display: none;
    }
  `,
};

export type LoadingIconProps = {
  inverted?: boolean;
  className?: string;
};

const LoadingIcon = React.forwardRef<HTMLDivElement, LoadingIconProps>(function LoadingIcon(
  { className, inverted },
  ref
) {
  return (
    <div ref={ref} className={className} css={styles.root}>
      <LoadingItem inverted={inverted} />
    </div>
  );
});

export default LoadingIcon;
